import { atom } from 'jotai';
import { atomWithStorage, createJSONStorage } from 'jotai/utils';

const practicePatientIdStorage = createJSONStorage<string | null>(
  () => sessionStorage,
);
const practiceImageIdStorage = createJSONStorage<string | null>(
  () => sessionStorage,
);
const imageTimestampStorage = createJSONStorage<string | null>(
  () => sessionStorage,
);
export const practicePatientIdAtom = atomWithStorage(
  'jotai-practicePatientId',
  '',
  practicePatientIdStorage,
);
export const practiceImageIdAtom = atomWithStorage(
  'jotai-practiceImageId',
  '',
  practiceImageIdStorage,
);
export const displayThresholdMaxAtom = atomWithStorage(
  'jotai-displayThresholdMax',
  false,
);
export const imageViewAtom = atomWithStorage('jotai-imageView', '');
export const externalPmsSourceAtom = atomWithStorage(
  'jotai-externalPmsSource',
  '',
);
export const videaPatientIdAtom = atomWithStorage('jotai-videaPatientId', '');
export const redirectToSwitchBoardAtom = atomWithStorage(
  'jotai-redirectToSwitchBoard',
  false,
);
export const imageTimestampAtom = atomWithStorage(
  'jotai-imageTimestamp',
  '',
  imageTimestampStorage,
);
